import { getRequest } from '@/core';
import { locations } from '@/requests';

export default async function getLocationsRequest(filter) {
	let url = locations.getPath();
	try {
		let response = await getRequest(url, filter);
		return response;
	} catch (err) {
		if (err.response && err.response.data) {
			throw new Error(err.response.data);
		}
		throw err;
	}
}
